import { defineStore } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useStatisticsStore = defineStore('statistics', {
  state: () => ({
    unit: '',
    periodRevenues:[],
    dailyRevenues: []
  }),

  getters:{
    periodRef: (state) => {
      const data = new Map()
      state.periodRevenues.forEach((e)=>{
        let totalRevenue = e.quantity * e.price
        let dishes = [{
          name: e.name,
          quantity: e.quantity,
          price: e.price
        }]

        let key = e.businessDate
        if(state.unit == 'day'){
          key = e.businessDate
        }else if(state.unit == 'month'){
          key = e.businessDate.substr(0,7)
        }else if(state.unit == 'year'){
          key = e.businessDate.substr(0,4)
        }

        // 集计key存在的情况下，加总和，push详细
        if(data.has(key)){
          const tmp = data.get(key)
          tmp.totalRevenue += totalRevenue
          let existDish = tmp.dishes.find(d => d.name == e.name && d.price == e.price)
          if(existDish){
            existDish.quantity += e.quantity
          }else{
            tmp.dishes = tmp.dishes.concat(dishes)
          }
        }else{
          data.set(key, {
            totalRevenue,
            dishes
          })
        }
      })
      return data
    },

    dailyRef: (state) => {
      return state.dailyRevenues.map( m => {
        let detailText = '';
        const paidOrders = m.orderList.filter(f => f.isPaid)
        const unpaidOrders = m.orderList.filter(f => !f.isPaid)

        if(paidOrders.length > 0){
          detailText += state.detailText(paidOrders, '已支付:')

          if(unpaidOrders.length > 0){
            detailText += '<br >'
          }
        }
        
        if(unpaidOrders.length > 0){
          detailText += state.detailText(unpaidOrders, '未支付:')
        }

        return {
          ...m,
          detailText
        }
      })
    }
  },

  actions:{
    setUnitType(unit){
      this.unit = unit
    },

    async getPeriodRevenue(startDate, endDate){
      this.periodRevenues = []
      this.periodRevenues =  await httpService.post(URL.STATISTICS_PERIOD_REVENUE_RETRIEVE, {startDate, endDate})
    },

    async getDailyRevenue(searchDate){
      this.dailyRevenues = []
      this.dailyRevenues =  await httpService.post(URL.STATISTICS_DAILY_REVENUE_RETRIEVE, {searchDate})
    },

    mergeDish(source, target){
      source.forEach(s => {
        const dish = target.find(t => {s.name == t.name && s.price == t.price})
        if(dish){
          dish.quantity += s.quantity
        }else{
          target.push({
            name : s.name,
            price : s.price,
            quantity : s.quantity
          })
        }
      })
    },

    dishesToText(dishes){
      let totalAmount = 0
      const text = dishes.map(dish => { 
        totalAmount += dish.quantity * dish.price
        return dish.name + ":" + dish.quantity + "份"
      }).join(', ')
      return totalAmount + '元<br >' + text
    },

    detailText(orders, title){
      const target = []
      orders.forEach( order => this.mergeDish( order.dishList, target))
      const text = this.dishesToText(target)
      if(text && text !== ''){
        return title + text
      }
      return ''
    }
  }
})